import { Instance, types } from 'mobx-state-tree'
import { Image } from './Image'

export const Office = types
  .model('Office', {
    id: types.number,
    name: types.string,
    address: types.string,
    zipCode: types.string,
    city: types.string,
    image: Image,
    description: types.maybeNull(types.string),
    website: types.maybeNull(types.string),
    landingpage: types.maybeNull(types.string),
    drFlexId: types.maybeNull(types.number),
    phone: types.maybeNull(types.string),
    locationLatitude: types.number,
    locationLongitude: types.number,
    distance: types.maybeNull(types.number),
    supportsAllOn4: types.boolean,
    bookingUrl: types.maybeNull(types.string),
    videoUrl: types.maybeNull(types.string),
  })
  .views((self) => ({
    get fullAddress() {
      return `${self.address}, ${self.zipCode} ${self.city}`
    },
    get videoId() {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
      var match = self.videoUrl.match(regExp)
      return match && match[7].length == 11 ? match[7] : false
    },
    get videoThumbnail() {
      return `https://img.youtube.com/vi/${self.videoId}/0.jpg`
    },
    getTruncatedDescription: (limit: number) => {
      const str = self.description
      if (str.length <= limit) return str
      const subString = str.substr(0, limit - 1)
      return subString.substr(0, subString.lastIndexOf(' ')) + '...'
    },
  }))

export type OfficeInstance = Instance<typeof Office>
